'use client';

import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';

const loadedMenuImages = new Set<string>();

export function resolveMenuImageUrl(imageUrl: string | null | undefined) {
    if (!imageUrl) {
        return '';
    }

    return getStaticAssetUrl(imageUrl);
}

export function isMenuImageLoaded(imageUrl: string | null | undefined) {
    const resolvedImageUrl = resolveMenuImageUrl(imageUrl);

    return Boolean(resolvedImageUrl && loadedMenuImages.has(resolvedImageUrl));
}

export function markMenuImageLoaded(imageUrl: string | null | undefined) {
    const resolvedImageUrl = resolveMenuImageUrl(imageUrl);

    if (!resolvedImageUrl) {
        return;
    }

    loadedMenuImages.add(resolvedImageUrl);
}

export function preloadMenuImage(imageUrl: string | null | undefined) {
    const resolvedImageUrl = resolveMenuImageUrl(imageUrl);

    if (!resolvedImageUrl || loadedMenuImages.has(resolvedImageUrl)) {
        return;
    }

    const image = new window.Image();
    image.decoding = 'async';
    image.src = resolvedImageUrl;

    if (image.complete && image.naturalWidth > 0) {
        loadedMenuImages.add(resolvedImageUrl);
        return;
    }

    const markLoaded = () => {
        loadedMenuImages.add(resolvedImageUrl);
    };

    image.addEventListener('load', markLoaded, { once: true });
    image.addEventListener('error', markLoaded, { once: true });
}
